import "core-js/modules/es.array.for-each";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _Message2 from "element-ui/lib/theme-chalk/message.css";
import "element-ui/lib/theme-chalk/base.css";
import _Message from "element-ui/lib/message";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapGetters } from 'vuex';
import { getFinancialBankInCounters } from '@/api/bairun/financialCenter';
import dateUtils from '@/utils/dateUtil';
import NP from 'number-precision';
export default {
  name: 'FinancialBankIn',
  data: function data() {
    var _this = this;

    return {
      refIndex: 0,
      stationBankData: [],
      stationBankList: {
        1000102028: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '户',
          bankAccount: '农行-公户-2028',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000106995: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '个',
          bankAccount: '北-邮政-6995',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100996: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '个',
          bankAccount: '邓-交行-0996',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100001: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100002: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100003: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100004: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100005: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000100006: {
          stationId: 10001,
          stationName: '梁村站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000202733: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '户',
          bankAccount: '农行公户2733',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000203539: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '个',
          bankAccount: '熙-中行3539',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200001: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200002: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200003: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200004: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200005: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000200006: {
          stationId: 10002,
          stationName: '隧洞口',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300090: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '户',
          bankAccount: '公户-0090',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000302595: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '熙招行-2595',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000309583: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '陆东红-华夏9583',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000306777: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '锐农行-6777',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300001: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300002: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300003: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300004: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300005: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000300006: {
          stationId: 10003,
          stationName: '天诚站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000402578: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '户',
          bankAccount: '公户-2578',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000405640: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '个',
          bankAccount: '熙农信-5640',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000409541: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '个',
          bankAccount: '谢中行-9541',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400001: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400002: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400003: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400004: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400005: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000400006: {
          stationId: 10004,
          stationName: '天纸站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500001: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500002: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500003: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500004: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500005: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000500006: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000509368: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '户',
          bankAccount: '利来公户（新）－9368',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000502838: {
          stationId: 10005,
          stationName: '利来站',
          bankType: '个',
          bankAccount: '勇邮政-2838',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000609208: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '户',
          bankAccount: '公户-9208',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000602980: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '维农信-2980',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000609633: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '张翠桃-华夏9633',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000602603: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '勇招行-2603',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600001: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600002: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600003: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600004: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600005: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000600006: {
          stationId: 10006,
          stationName: '中洲站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000805498: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '户',
          bankAccount: '广西农商-（一般户5498）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000802587: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '个',
          bankAccount: '许剑锋-招商--2587',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800001: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800002: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800003: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800004: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800005: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000800006: {
          stationId: 10008,
          stationName: '合浦站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000907624: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '户',
          bankAccount: '公户-7624',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000908971: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '个',
          bankAccount: '陆东红农行-8971',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900001: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900002: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900003: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900004: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900005: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1000900006: {
          stationId: 10009,
          stationName: '得琛站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001005847: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '户',
          bankAccount: '基本户5847',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001005920: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '个',
          bankAccount: '一般户5920',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000709: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '个',
          bankAccount: '张楚维-邮政0709',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000001: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000002: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000003: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000004: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000005: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001000006: {
          stationId: 10010,
          stationName: '榴边站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001104495: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '户',
          bankAccount: '公户-4495',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001105816: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '北华夏-5816',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100632: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '娣交行-0632',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001109641: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '张楚维-华夏9641',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001102980: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '维农信-2980',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100001: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100002: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100003: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100004: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100005: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001100006: {
          stationId: 10011,
          stationName: '莲子塘',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001203854: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '户',
          bankAccount: '公户-3854',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001206839: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '个',
          bankAccount: '潘农信-6839',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001209845: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '个',
          bankAccount: '邓招行-9845',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200001: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200002: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200003: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200004: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200005: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001200006: {
          stationId: 10012,
          stationName: '新北站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001301451: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '户',
          bankAccount: '公户-1451',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001304906: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '个',
          bankAccount: '一般户-4906',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001302447: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '个',
          bankAccount: '何招行-2447',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300001: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300002: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300003: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300004: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300005: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001300006: {
          stationId: 10013,
          stationName: '恭讯站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400001: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400002: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400003: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400004: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400005: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001400006: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001402610: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '户',
          bankAccount: '公户-2610',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001405514: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '个',
          bankAccount: '张楚维农信-5514',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001403919: {
          stationId: 10014,
          stationName: '沙田站',
          bankType: '个',
          bankAccount: '沙田冯中行-3919',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001502502: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '户',
          bankAccount: '公户-2502',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001503771: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '个',
          bankAccount: '黄丽珍工行-3771',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001503862: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '个',
          bankAccount: '黄丽珍建行-3862',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500001: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '个',
          bankAccount: '通联分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500002: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '户',
          bankAccount: '通联分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500003: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '个',
          bankAccount: '拉卡拉分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500004: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '户',
          bankAccount: '拉卡拉分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500005: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '个',
          bankAccount: '富友分账（个）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        },
        1001500006: {
          stationId: 10015,
          stationName: '金龙辰',
          bankType: '户',
          bankAccount: '富友分账（户）',
          transferAmount: 0,
          plat2001Amount: 0,
          plat2002Amount: 0,
          plat2003Amount: 0,
          plat2004Amount: 0,
          plat2005Amount: 0,
          plat2007Amount: 0,
          plat1008Amount: 0,
          plat2008Amount: 0,
          plat2009Amount: 0,
          plat2010Amount: 0,
          plat2011Amount: 0,
          plat2012Amount: 0,
          plat2013Amount: 0,
          plat2014Amount: 0,
          cashAmount: 0,
          posAmount: 0,
          onlineAmount: 0,
          lklPosAmount: 0,
          lklOnlineAmount: 0,
          fyPosAmount: 0,
          fyOnlineAmount: 0,
          totalAmount: 0,
          totalGeAmount: 0,
          totalHuAmount: 0
        }
      },
      stationBankListTemp: {},
      bankRules: {
        '10001': {
          '1006': '1000102028',
          '2001': '1000102028',
          '2003': '1000102028',
          '2004': '1000102028',
          '1001': '1000106995',
          '2005': '1000106995',
          '1003_g': '1000100001',
          '1004_g': '1000100001',
          '1003': '1000100002',
          '1004': '1000100002',
          '1013_g': '1000100003',
          '1014_g': '1000100003',
          '1013': '1000100004',
          '1014': '1000100004',
          '1023_g': '1000100005',
          '1024_g': '1000100005',
          '1023': '1000100006',
          '1024': '1000100006',
          'default': '1000100996'
        },
        '10002': {
          '1006': '1000202733',
          '2001': '1000202733',
          '2004': '1000202733',
          '1001': '1000202733',
          '1003_g': '1000200001',
          '1004_g': '1000200001',
          '1003': '1000200002',
          '1004': '1000200002',
          '1013_g': '1000200003',
          '1014_g': '1000200003',
          '1013': '1000200004',
          '1014': '1000200004',
          '1023_g': '1000200005',
          '1024_g': '1000200005',
          '1023': '1000200006',
          '1024': '1000200006',
          'default': '1000203539'
        },
        '10003': {
          '1006': '1000300090',
          '2001': '1000300090',
          '1001': '1000300090',
          '1005': '1000309583',
          '1001_g': '1000300090',
          '1003_g': '1000300001',
          '1004_g': '1000300001',
          '1003': '1000300002',
          '1004': '1000300002',
          '1013_g': '1000300003',
          '1014_g': '1000300003',
          '1013': '1000300004',
          '1014': '1000300004',
          '1023_g': '1000300005',
          '1024_g': '1000300005',
          '1023': '1000300006',
          '1024': '1000300006',
          'default': '1000302595'
        },
        '10004': {
          '1006': '1000402578',
          '2001': '1000402578',
          '2004': '1000402578',
          '1001': '1000402578',
          '1001_g': '1000405640',
          '2005': '1000405640',
          '1003_g': '1000400001',
          '1004_g': '1000400001',
          '1003': '1000400002',
          '1004': '1000400002',
          '1013_g': '1000400003',
          '1014_g': '1000400003',
          '1013': '1000400004',
          '1014': '1000400004',
          '1023_g': '1000400005',
          '1024_g': '1000400005',
          '1023': '1000400006',
          '1024': '1000400006',
          'default': '1000409541'
        },
        '10005': {
          '1006': '1000509368',
          '2001': '1000509368',
          '2004': '1000509368',
          '1001': '1000509368',
          '1001_g': '1000502838',
          '1003_g': '1000500001',
          '1004_g': '1000500001',
          '1003': '1000500002',
          '1004': '1000500002',
          '1013_g': '1000500003',
          '1014_g': '1000500003',
          '1013': '1000500004',
          '1014': '1000500004',
          '1023_g': '1000500005',
          '1024_g': '1000500005',
          '1023': '1000500006',
          '1024': '1000500006',
          'default': '1000502838'
        },
        '10006': {
          '1006': '1000609208',
          '1005': '1000609633',
          '2002': '1000602603',
          '2005': '1000602603',
          '1003_g': '1000600001',
          '1004_g': '1000600001',
          '1003': '1000600002',
          '1004': '1000600002',
          '1013_g': '1000600003',
          '1014_g': '1000600003',
          '1013': '1000600004',
          '1014': '1000600004',
          '1023_g': '1000600005',
          '1024_g': '1000600005',
          '1023': '1000600006',
          '1024': '1000600006',
          '1001': '1000609208',
          '1001_g': '1000602980',
          'default': '1000609208'
        },
        '10008': {
          '1006': '1000805498',
          '1005': '1000805498',
          '2005': '1000802587',
          '1003_g': '1000800001',
          '1004_g': '1000800001',
          '1003': '1000800002',
          '1004': '1000800002',
          '1013_g': '1000800003',
          '1014_g': '1000800003',
          '1013': '1000800004',
          '1014': '1000800004',
          '1023_g': '1000800005',
          '1024_g': '1000800005',
          '1023': '1000800006',
          '1024': '1000800006',
          'default': '1000805498'
        },
        '10009': {
          '1006': '1000907624',
          '2001': '1000907624',
          '2004': '1000907624',
          '1001': '1000907624',
          '1001_g': '1000908971',
          '1003_g': '1000900001',
          '1004_g': '1000900001',
          '1003': '1000900002',
          '1004': '1000900002',
          '1013_g': '1000900003',
          '1014_g': '1000900003',
          '1013': '1000900004',
          '1014': '1000900004',
          '1023_g': '1000900005',
          '1024_g': '1000900005',
          '1023': '1000900006',
          '1024': '1000900006',
          'default': '1000908971'
        },
        '10010': {
          '1006': '1001005847',
          '2001': '1001005847',
          '2003': '1001005847',
          '2004': '1001005847',
          '1001': '1001005920',
          '1003_g': '1001000001',
          '1004_g': '1001000001',
          '1003': '1001000002',
          '1004': '1001000002',
          '1013_g': '1001000003',
          '1014_g': '1001000003',
          '1013': '1001000004',
          '1014': '1001000004',
          '1023_g': '1001000005',
          '1024_g': '1001000005',
          '1023': '1001000006',
          '1024': '1001000006',
          'default': '1001000709'
        },
        '10011': {
          '1006': '1001104495',
          '2005': '1001105816',
          '2002': '1001100632',
          '1005': '1001109641',
          '2011': '1001102980',
          '1003_g': '1001100001',
          '1004_g': '1001100001',
          '1003': '1001100002',
          '1004': '1001100002',
          '1013_g': '1001100003',
          '1014_g': '1001100003',
          '1013': '1001100004',
          '1014': '1001100004',
          '1023_g': '1001100005',
          '1024_g': '1001100005',
          '1023': '1001100006',
          '1024': '1001100006',
          'default': '1001104495'
        },
        '10012': {
          '1006': '1001203854',
          '2002': '1001209845',
          '2005': '1001209845',
          '1005': '1001209845',
          '1003_g': '1001200001',
          '1004_g': '1001200001',
          '1003': '1001200002',
          '1004': '1001200002',
          '1013_g': '1001200003',
          '1014_g': '1001200003',
          '1013': '1001200004',
          '1014': '1001200004',
          '1023_g': '1001200005',
          '1024_g': '1001200005',
          '1023': '1001200006',
          '1024': '1001200006',
          '1001': '1001203854',
          '1001_g': '1001206839',
          'default': '1001203854'
        },
        '10013': {
          '1006': '1001301451',
          '2002': '1001302447',
          '2005': '1001302447',
          '1005': '1001302447',
          '1001': '1001304906',
          '1003_g': '1001300001',
          '1004_g': '1001300001',
          '1003': '1001300002',
          '1004': '1001300002',
          '1013_g': '1001300003',
          '1014_g': '1001300003',
          '1013': '1001300004',
          '1014': '1001300004',
          '1023_g': '1001300005',
          '1024_g': '1001300005',
          '1023': '1001300006',
          '1024': '1001300006',
          'default': '1001301451'
        },
        '10014': {
          '1006': '1001402610',
          '2001': '1001402610',
          '2004': '1001402610',
          '2007': '1001402610',
          '1001': '1001402610',
          '1001_g': '1001405514',
          '1003_g': '1001400001',
          '1004_g': '1001400001',
          '1003': '1001400002',
          '1004': '1001400002',
          '1013_g': '1001400003',
          '1014_g': '1001400003',
          '1013': '1001400004',
          '1014': '1001400004',
          '1023_g': '1001400005',
          '1024_g': '1001400005',
          '1023': '1001400006',
          '1024': '1001400006',
          'default': '1001405514'
        },
        '10015': {
          '1006': '1001502502',
          '2001': '1001502502',
          '2004': '1001502502',
          '1003_g': '1001500001',
          '1004_g': '1001500001',
          '1003': '1001500002',
          '1004': '1001500002',
          '1013_g': '1001500003',
          '1014_g': '1001500003',
          '1013': '1001500004',
          '1014': '1001500004',
          '1023_g': '1001500005',
          '1024_g': '1001500005',
          '1023': '1001500006',
          '1024': '1001500006',
          'default': '1001503862'
        }
      },
      datePickerValue: dateUtils.todayTimestamp() * 1000 - 86400 * 1000,
      nextStep: false,
      excelSheets: [{
        tableId: 'stationBankData',
        name: '财务到账日报表',
        tableRows: 3
      }],
      spanArr: [],
      position: 0,
      downloadLoading: false,
      pickerOptionsLimit: {
        disabledDate: function disabledDate(pTime) {
          return _this.userInfo.authorityId === '888' ? false : pTime.getTime() < new Date() - 91 * 86400 * 1000 || pTime.getTime() > new Date() - 86400 * 1000;
        }
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters('user', ['userInfo'])), mapGetters('stations', ['asyncStations'])),
  updated: function updated() {
    var _this2 = this;

    this.$nextTick(function () {
      _this2.$refs.stationBankData.doLayout();
    });
  },
  created: function created() {},
  methods: {
    financialSearch: function financialSearch() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.stationBankData.doLayout();
      });
      this.loadData();
    },
    loadData: function loadData() {
      var _this4 = this;

      this.stationBankData = [];
      this.stationBankListTemp = {};
      this.stationBankListTemp = JSON.parse(JSON.stringify(this.stationBankList));
      this.downloadLoading = true;
      this.position = 0;
      this.spanArr = [];
      getFinancialBankInCounters({
        startDate: dateUtils.timeStampToString(this.datePickerValue / 1000, 'YYYYMMDD'),
        endDate: dateUtils.timeStampToString(this.datePickerValue / 1000, 'YYYYMMDD')
      }).then(function (response) {
        _this4.downloadLoading = false; // console.log('getFinancialBankInCounters', response)

        var res = response.data;
        _this4.nextStep = res.length > 0;

        if (res.length === 0) {
          return;
        }

        for (var i in res) {
          _this4.handleResData(res[i]);
        }

        _this4.onMergeLines();
      }).catch(function () {
        _this4.downloadLoading = false;
      });
    },
    tableRowClassName: function tableRowClassName(_ref) {
      var row = _ref.row,
          rowIndex = _ref.rowIndex;

      if (row.bankType === '户') {
        return 'warning-row';
      }

      return '';
    },
    npPlusArr: function npPlusArr(arr) {
      var res = 0;

      for (var i in arr) {
        res = NP.plus(res, Number(arr[i]));
      }

      return res;
    },
    handleResData: function handleResData(item) {
      if (item.stationId < 10000 || !this.bankRules[item.stationId]) {
        return;
      }

      var bankRuleItem = this.bankRules[item.stationId];
      var listIndex = bankRuleItem[item.payWay] ? bankRuleItem[item.payWay] : bankRuleItem['default'];
      var propertyIndex = '';
      var amountIndex = '';

      if (item.payWay === 1003 || item.payWay === 1004) {
        propertyIndex = 'onlineAmount';
        amountIndex = 'receivablesAmount';
      } else if (item.payWay === 1013 || item.payWay === 1014) {
        propertyIndex = 'lklOnlineAmount';
        amountIndex = 'receivablesAmount';
      } else if (item.payWay === 1023 || item.payWay === 1024) {
        propertyIndex = 'fyOnlineAmount';
        amountIndex = 'receivablesAmount';
      } else if (item.payWay === 1005) {
        propertyIndex = 'posAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay === 1015) {
        propertyIndex = 'lklPosAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay === 1025) {
        propertyIndex = 'fyPosAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay === 1045) {
        propertyIndex = 'xyPosAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay === 1001) {
        propertyIndex = 'cashAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay === 1006) {
        propertyIndex = 'transferAmount';
        amountIndex = 'checkPaymentsAmount';
      } else if (item.payWay < 3000 && item.payWay > 2000 || item.payWay === 1008) {
        propertyIndex = 'plat' + item.payWay + 'Amount';
        amountIndex = 'checkPaymentsAmount';
      } else {
        return;
      }

      if (!item[amountIndex]) {
        return;
      }

      var calValue = item[amountIndex];

      if (item.payWay === 1001) {
        // 现金有存行金额  以存行数据展示  否则以主管核对金额入公显示
        calValue = item['bankCashDeposit']['depositValue'] > 0 ? item['bankCashDeposit']['depositValue'] : this.npPlusArr(calValue.split('|'));

        if (item['bankCashDeposit']['depositValue'] > 0 && item['bankCashDeposit']['bankType'] === '个' && bankRuleItem['1001_g']) {
          listIndex = bankRuleItem['1001_g'];
        }
      }

      if ((item.payWay === 1003 || item.payWay === 1004 || item.payWay === 1013 || item.payWay === 1014 || item.payWay === 1023 || item.payWay === 1024) && bankRuleItem[item.payWay + '_g']) {
        // 如果是通联数据 入个单独显示一份数据
        var geCalValue = NP.times(NP.divide(100 - item['receivablesRatio'], 100), calValue); // 入个

        var geListIndex = bankRuleItem[item.payWay + '_g'];
        calValue = NP.minus(calValue, geCalValue); // console.log('stationBankListTemp allin ge', geListIndex, propertyIndex, geCalValue)

        this.stationBankListTemp[geListIndex][propertyIndex] = NP.plus(this.stationBankListTemp[geListIndex][propertyIndex], geCalValue);
        this.stationBankListTemp[geListIndex]['totalAmount'] = NP.plus(this.stationBankListTemp[geListIndex]['totalAmount'], geCalValue);
      } // console.log('stationBankListTemp', listIndex, propertyIndex, calValue)


      this.stationBankListTemp[listIndex][propertyIndex] = NP.plus(this.stationBankListTemp[listIndex][propertyIndex], calValue);
      this.stationBankListTemp[listIndex]['totalAmount'] = NP.plus(this.stationBankListTemp[listIndex]['totalAmount'], calValue);
    },
    onMergeLines: function onMergeLines() {
      var _this5 = this;

      for (var property in this.stationBankListTemp) {
        if (!this.stationBankListTemp[property]) {
          continue;
        }

        this.stationBankData.push(this.stationBankListTemp[property]);
      }

      this.stationBankData.forEach(function (item, index) {
        if (index === 0) {
          _this5.spanArr.push(1);

          _this5.position = 0;
        } else {
          // 判断当前与上一个
          if (_this5.stationBankData[index].stationId === _this5.stationBankData[index - 1].stationId) {
            _this5.spanArr[_this5.position] += 1;

            _this5.spanArr.push(0);
          } else {
            _this5.spanArr.push(1);

            _this5.position = index;
          }
        }

        if (item['bankType'] === '个') {
          _this5.stationBankData[_this5.position]['totalGeAmount'] = NP.plus(_this5.stationBankData[_this5.position]['totalGeAmount'], _this5.stationBankData[index]['totalAmount']);
        }

        if (item['bankType'] === '户') {
          _this5.stationBankData[_this5.position]['totalHuAmount'] = NP.plus(_this5.stationBankData[_this5.position]['totalHuAmount'], _this5.stationBankData[index]['totalAmount']);
        }
      });
      console.log('this.stationBankData', this.stationBankData);
    },
    objectSpanMethod: function objectSpanMethod(_ref2) {
      var row = _ref2.row,
          column = _ref2.column,
          rowIndex = _ref2.rowIndex,
          columnIndex = _ref2.columnIndex;

      if (columnIndex === 0 || columnIndex === 25 || columnIndex === 26) {
        var aRow = this.spanArr[rowIndex];
        var aCol = aRow > 0 ? 1 : 0;
        return {
          rowspan: aRow,
          colspan: aCol
        };
      }
    },
    exportExcel: function exportExcel(tableArr, excelName) {
      var _this6 = this;

      if (tableArr.length < 1) {
        _Message({
          message: '导出 sheet 为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      if (!this.nextStep) {
        _Message({
          message: '查询的数据为空',
          type: 'error',
          duration: 3 * 1000
        });

        return;
      }

      this.downloadLoading = true;
      import('@/utils/Export2Excel').then(function (excel) {
        excel.export_table_to_excel(tableArr, dateUtils.timeStampToString(_this6.datePickerValue / 1000, 'YYYY年MM月DD日') + excelName);
        _this6.downloadLoading = false;
      });
    }
  }
};